import { ReactNode } from 'react';
import styled, { keyframes } from 'styled-components';

const radioSize = 10;
const radioSizeChecked = 8;
const radioSizeRipple = 10;

const ripple = keyframes`
  0% {
    box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.0);
  }

  50% { 
    box-shadow: 0px 0px 0px ${radioSizeRipple} rgba(0, 0, 0, 0.1);
  }

  100% {
    box-shadow: 0px 0px 0px ${radioSizeRipple} rgba(0, 0, 0, 0);
  }
`;
interface InputProps {
  type?: string;
  name?: string;
  value?: any;
  checked?: boolean;
  onChange?: any;
  id?: string;
  ref?: any;
}

export const Input = styled.input<InputProps>``;

interface LabelProps {
  children?: ReactNode;
  htmlFor?: string;
}

export const Label = styled.label<LabelProps>``;

interface WrapperProps {
  children?: ReactNode;
}

export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  align-items: center;

  ${Input} {
    display: none;

    &:checked + label:before {
      border-color: ${({ theme }) => theme.colors.actionBtn};
      animation: ${ripple} 0.2s linear forwards;
    }

    &:checked + label:after {
      transform: scale(1);
    }
  }

  ${Label} {
    display: inline-block;
    height: ${radioSize}px;
    position: relative;
    padding: 0 ${radioSize + 10}px;
    margin-bottom: 0;
    cursor: pointer;
    vertical-align: bottom;

    &:before,
    &:after {
      position: absolute;
      content: '';
      border-radius: 50%;
      transition: all 0.3s ease;
      transition-property: transform, border-color;
    }

    &:before {
      left: 0;
      top: 0;
      width: ${radioSize}px;
      height: ${radioSize}px;
      border: 2px solid rgba(0, 0, 0, 0.54);
    }

    &:after {
      top: 3px;
      left: 3px;
      width: ${radioSizeChecked}px;
      height: ${radioSizeChecked}px;
      transform: scale(0);
      background: ${({ theme }) => theme.colors.actionBtn};
    }
  }
`;
